import { render, staticRenderFns } from "@/modules/Book/templates/books-list.html?vue&type=template&id=89fe8aac&scoped=true&"
import script from "@/modules/Book/scripts/books-list.ts?vue&type=script&lang=js&"
export * from "@/modules/Book/scripts/books-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Book/styles/books-list.scss?vue&type=style&index=0&id=89fe8aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fe8aac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
